import { useAuth } from "@/contexts/AuthContext";

export default function Profile() {
  const { user } = useAuth();
  return (
    <div data-testid="profile-page">
      <div className="eyebrow mb-1">Profile</div>
      <h1 className="font-display text-2xl sm:text-3xl uppercase mb-5 sm:mb-6">My Account</h1>
      <div className="kr-card rounded-xl p-5 sm:p-8 max-w-2xl">
        <div className="space-y-4">
          {[
            ["Name", user?.name],
            ["Email", user?.email],
            ["Phone", user?.phone || "—"],
            ["Role", user?.role],
          ].map(([k, v]) => (
            <div key={k} className="flex flex-col sm:flex-row sm:justify-between gap-1 border-b border-white/10 pb-3 last:border-0">
              <div className="text-slate-400 text-xs sm:text-sm uppercase tracking-widest sm:tracking-normal sm:normal-case">{k}</div>
              <div className="font-semibold break-all">{v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
